module.exports = __webpack_public_path__ + "static/media/fedpa-phone.9ed796e9.svg";